import Effects from 'effects/Effects.js';
import Tone from 'tone';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

class GateEffect extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Gate", () => new Tone.Gain(2), sequencerEngine);
        this.connectedTrack = undefined;
        this.follower = new Tone.Follower(0.012, 0.1);
        this.multiplier = new Tone.Gain(100);
        this.gate = new Tone.Gate(-30, 0.001, 0.2);
        this.smoothingParameter = new AbstractParameter(
            'Smoothing', this, (o, x) => this.gate.smoothing = x, {
                min: 0.00001,
                max: 2,
                unit: 'ms',
                defaultValue: 0.012
            });
        this.thresholdParameter = new AbstractParameter(
            'Threshold', this, (o, x) => this.gate.threshold = x, {
                min: -30,
                max: 6,
                unit: 'db',
                defaultValue: 0
            });

        this.registerParameter(this.smoothingParameter);
        this.registerParameter(this.thresholdParameter);

        this.effectNode.connect(this.gate);
        this.updateInitialValues();
    }

    connect(x) {
        this.gate.connect(x);
    }

    disconnect(x) {
        this.gate.disconnect(x);
    }

    get smoothing() {
        return this.smoothingParameter.get();
    }

    set smoothing(x) {
        return this.smoothingParameter.set(x);
    }

    get threshold() {
        return this.thresholdParameter.get();
    }

    set threshold(x) {
        return this.thresholdParameter.set(x);
    }

    setSideChainedTrack(track, trackNumber) {
        if (this.connectedTrack !== undefined) {
            this.connectedTrack.volumeNode.disconnect(this.multiplier);
        }

        track.volumeNode.chain(this.multiplier, this.follower);
        this.follower.connect(this.effectNode.gain);
        this.connectedTrack = track;
        this.trackNumber = trackNumber;
    }

    getJson() {
        let json = super.getJson();
        json.trackNumber = this.trackNumber;
        json.threshold = this.threshold;
        json.smoothing = this.smoothing;
        json = this.saveParameterToJson(json, 'smoothingParameter', this.smoothingParameter);
        json = this.saveParameterToJson(json, 'thresholdParameter', this.thresholdParameter);
        return json;
    }
    
    fromJson(json, tracks, isCopy) {
        super.fromJson(json, isCopy);
        if (json.enabled) {
            this.enable(true);
        }

        this.threshold = json.threshold;
        this.smoothing = json.smoothing;
        this.setSideChainedTrack(tracks[json.trackNumber], json.trackNumber);

        this.loadParameterFromJson(json, 'thresholdParameter', this.thresholdParameter);
        this.loadParameterFromJson(json, 'smoothingParameter', this.smoothingParameter);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new GateEffect(sequencerEngine);
        copy.fromJson(this.getJson(), this.sequencerEngine.tracks, ignoreId);
        return copy;
    }
}

export default GateEffect;
